// import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material'
// import React from 'react'
// import { Controller } from 'react-hook-form'

// const ITEM_HEIGHT = 48
// const ITEM_PADDING_TOP = 8
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250,
//     },
//   },
// }

// const SelectForm = ({ control, data, errors, dynamicField, label, disabled, id, name, required }) => {
//   return (
//       <Controller
//         name={name}
//         control={control}
//         defaultValue=""
//         rules={{
//           required: {
//             value: required,
//             message: 'This field is required',
//           },
//         }}
//         render={({ field }) => {

//               return (
//           <FormControl fullWidth error={Boolean(errors?.[name])} disabled={disabled} size="small">
//             <InputLabel>{label}</InputLabel>
//             <Select
//               {...field}
//               label={label}
//               error={errors?.[name]}
//               MenuProps={MenuProps}
//               value={field.value || ''}
//               sx={disabled ? { backgroundColor: 'hsl(0, 0%, 95%)' } : {}}
//             >
//               {data?.map((item) =>{ 
//                 return (
//  <MenuItem key={item?.[id]} value={item?.[id]}>
//                   <Box display="flex" gap={1} alignItems="center">
//                     <Box display="inlineBlock" sx={{ minWidth: '50px' }}>
//                       {item?.[name]}
//                     </Box>
//                     {item?.icon}
//                   </Box>
//                 </MenuItem>
//               )}

//               )}
//             </Select>
//             {errors?.[name] && <FormHelperText>{errors?.[name].message}</FormHelperText>}
//           </FormControl>
//   )}
//         }
//       />
//   )
// }

// export default SelectForm



import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react'
import { Controller } from 'react-hook-form';
import SelectBox from '../CustomInputs/Select/SelectBox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const SelectForm = ({ control, data, errors, dynamicField, label, disabled, id, name, required }) => {
    return (
        <div>
            <FormControl fullWidth error={Boolean(errors?.[dynamicField])} disabled={disabled} size='small'>
                <InputLabel>{label}</InputLabel>
                <Controller
                    name={dynamicField}
                    control={control}
                    defaultValue=''
                    rules={{
                        required: {
                            value: required,
                            message: 'This field is required',
                        },
                    }}
                    render={({ field }) => (
                        <Select
                            {...field}
                            label={label}
                            MenuProps={MenuProps}
                            value={field.value !== undefined ? field.value : ''}
                            sx={disabled ? { backgroundColor: 'hsl(0, 0%, 95%)' } : {}}
                        >
                            {data?.map((item) => (
                                <MenuItem key={item?.[id]} value={item?.[id]}>
                                    <Box display="flex" gap={1} alignItems="center">
                                        <Box display="inlineBlock" sx={{ minWidth: '50px' }}>{item?.[name]}</Box>
                                        {item?.icon}
                                    </Box>
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                />
                {errors?.[dynamicField] && <FormHelperText>{errors?.[dynamicField].message}</FormHelperText>}
            </FormControl>
        </div>
    );
};


export default SelectForm